<template>
  <div id="app">
    <router-view />
    <UpdateNotification
      :newVersion="newVersionAvailable"
      @refresh="handleRefresh"
    />
    <LimitPaywallModal />
    <!-- <ChatBot /> -->
  </div>
</template>

<script>
import appConfig from "@/app.config";
import { notificationMethods } from "@/state/helpers";
import versionChecker from "@/helpers/versionCheck";
import UpdateNotification from "@/components/UpdateNotification.vue";
import LimitPaywallModal from "@/components/custom/LimitPaywallModal.vue";
// import ChatBot from "@/components/ChatBot.vue";


export default {
  name: "app",
  components: {
    UpdateNotification,
    LimitPaywallModal,
    // ChatBot
  },
  data() {
    return {
      newVersionAvailable: null
    }
  },
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
    handleUpdateAvailable(newVersion) {
      this.newVersionAvailable = newVersion;
    },
    handleRefresh() {
      versionChecker.forceRefresh();
    }
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    $route() {
      // clear alert on location change
      this.clearNotification();
    },
  },
  mounted() {
    // document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
    
    // Start version checking
    versionChecker.startChecking(this.handleUpdateAvailable);
  },
  beforeUnmount() {
    // Stop version checking when app is unmounted
    versionChecker.stopChecking();
  }
};
</script>
